import React, { FC } from 'react';
import { Box } from '@mui/material';
import UserLogin from '../components/LoginScreenComponents/UserLogin';

const Login: FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        minWidth: '100vw',
        height: '100%',
        width: '100%',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          minHeight: '100vh',
          minWidth: '100vw',
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <UserLogin />
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
